import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children"];
import UIRouterIconButton from 'ui-addon-react-router-dom/UIRouterIconButton';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BackButton = styled(_ref => {
  let {
      use = 'link',
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(UIRouterIconButton, Object.assign({
    use: use
  }, props, {
    children: [/*#__PURE__*/_jsx(LeftIcon, {}), children]
  }));
}).withConfig({
  displayName: "BackButton"
})(["&&{font-size:14px;text-decoration:none;font-weight:500;}"]);
export default BackButton;